<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateProductManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" class="demo-form-inline text-left">
        <el-form-item>
          <el-input
            v-model="affiliateProductManageInfo.conditions.productName"
            :placeholder="$t('affiliateProductManage.selectAffiliateProduct')"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="_queryAffiliateProductMethod">
            {{ $t('affiliateProductManage.query') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px;">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateProductManage.affiliateProduct') }}</span>
        <el-button
          type="primary"
          size="small"
          @click="_openAddAffiliateProductModal"
        >
          {{ $t('affiliateProductManage.add') }}
        </el-button>
      </div>
      <el-table
        :data="affiliateProductManageInfo.affiliateProducts"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="productId"
          :label="$t('affiliateProductManage.id')"
          align="center"
        />
        <el-table-column
          prop="productName"
          :label="$t('affiliateProductManage.name')"
          align="center"
        />
        <el-table-column
          prop="seq"
          :label="$t('affiliateProductManage.sort')"
          align="center"
        />
        <el-table-column
          :label="$t('affiliateProductManage.operation')"
          align="center"
          width="200"
        >
          <template #default="{row}">
            <el-button
              size="mini"
              @click="_openEditAffiliateProductModel(row)"
            >
              {{ $t('affiliateProductManage.edit') }}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="_openDeleteAffiliateProductModel(row)"
            >
              {{ $t('affiliateProductManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="affiliateProductManageInfo.conditions.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="affiliateProductManageInfo.conditions.row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="affiliateProductManageInfo.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="margin-top: 20px; text-align: right;"
      />
    </el-card>

    <add-affiliate-product ref="addAffiliateProduct" @refresh="_listAffiliateProducts" />
    <edit-affiliate-product ref="editAffiliateProduct" @refresh="_listAffiliateProducts" />
    <delete-affiliate-product ref="deleteAffiliateProduct" @refresh="_listAffiliateProducts" />
  </div>
</template>

<script>
import { listAffiliateProduct } from '@/api/affiliate/affiliateProductApi'
import AddAffiliateProduct from '@/components/affiliate/addAffiliateProduct'
import EditAffiliateProduct from '@/components/affiliate/editAffiliateProduct'
import DeleteAffiliateProduct from '@/components/affiliate/deleteAffiliateProduct'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AffiliateProductManage',
  components: {
    AddAffiliateProduct,
    EditAffiliateProduct,
    DeleteAffiliateProduct
  },
  data() {
    return {
      loading: false,
      affiliateProductManageInfo: {
        affiliateProducts: [],
        total: 0,
        conditions: {
          productName: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this.affiliateProductManageInfo.conditions.shopId = getShopId()
    this._listAffiliateProducts()
  },
  methods: {
    async _listAffiliateProducts() {
      this.loading = true
      try {
        const res = await listAffiliateProduct(this.affiliateProductManageInfo.conditions)
        this.affiliateProductManageInfo.affiliateProducts = res.data
        this.affiliateProductManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.affiliateProductManageInfo.conditions.row = val
      this._listAffiliateProducts()
    },
    handleCurrentChange(val) {
      this.affiliateProductManageInfo.conditions.page = val
      this._listAffiliateProducts()
    },
    _queryAffiliateProductMethod() {
      this.affiliateProductManageInfo.conditions.page = 1
      this._listAffiliateProducts()
    },
    _openAddAffiliateProductModal() {
      this.$refs.addAffiliateProduct.open()
    },
    _openEditAffiliateProductModel(row) {
      this.$refs.editAffiliateProduct.open(row)
    },
    _openDeleteAffiliateProductModel(row) {
      this.$refs.deleteAffiliateProduct.open(row)
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 样式，无需自定义样式 */
</style>